import DayKeeperPreview from './CanonicalDesignPage';

type StartPageProps = {
  busy: boolean;
  error: string | null;
  onApple(): void;
  onGuest(): void;
  guestEnabled: boolean;
};

export const StartPage = ({ busy, error, onApple, onGuest, guestEnabled }: StartPageProps) => (
  <DayKeeperPreview
    initialLoggedIn={false}
    busy={busy}
    error={error}
    guestEnabled={guestEnabled}
    onApple={onApple}
    onGuest={onGuest}
  />
);
